import React from 'react'
import { StudentAwardsList } from '../ActivitiesAwards/StudentAwardsList'

const AwardsProfile = ({ studentId }) => {
	return (
		<div className="card mb-4 shadow-sm" style={{ borderRadius: '8px' }}>
			<div className="card-header border-bottom">
				<h5 className="mb-0">Student Award List</h5>
			</div>
			<div className="card-body p-0">
				<StudentAwardsList studentId={studentId} isStudentView={true} isProfile={true} />
			</div>
		</div>
	)
}

export { AwardsProfile }
